import React, { useEffect, useState } from 'react';
import { Message } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { useDispatch, useSelector } from 'react-redux';
import { verifyPhoneNumberSelector } from '~/App/shared/selectors/verifyPhoneNumberSelector';
import {
  resetPhoneVerification,
  sendVerificationCode
} from '~/App/shared/actions/verifyPhoneNumber';
import EnterCode from '~/App/shared/components/VerifyPhoneNumber/components/EnterCode';
import StatusPageLoading from '~/App/shared/components/StatusPageLoading';
import OrganisationMemberDetailsForm, {
  FormData
} from './OrganisationMemberDetailsForm';
import { useMemberDataUpdate } from '../../hooks/useMemberDataUpdate';

interface Props {
  handleClose?: () => void;
  isPending: boolean;
  setIsPending: (isPending: boolean) => void;
}

const BiddingOrgPersonPhoneVerification = ({
  isPending,
  setIsPending
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { error, generalError, isSendingCode, isVerified } = useSelector(
    verifyPhoneNumberSelector
  );
  const [organisationDetailsFormData, setOrganisationDetailsFormData] =
    useState<FormData | null>(null);
  const {
    saveAccountDetailsCallback,
    isSavingAccountDetails,
    isSavingAccountDetailsError
  } = useMemberDataUpdate();
  const isError = error || generalError || isSavingAccountDetailsError;

  useEffect(() => {
    return () => dispatch(resetPhoneVerification());
  }, [dispatch]);

  useEffect(() => {
    if (isVerified && organisationDetailsFormData) {
      void saveAccountDetailsCallback(organisationDetailsFormData);
    }
  }, [isVerified, saveAccountDetailsCallback, organisationDetailsFormData]);

  if (isPending) {
    return (
      <>
        {(isSendingCode || isSavingAccountDetails) && <StatusPageLoading />}
        {isError && (
          <Message type="error" fullWidth>
            {error || t('Something went wrong, please try again later.')}
          </Message>
        )}
        {!isSendingCode && !isSavingAccountDetails && !isError && (
          <EnterCode handleClose={() => setIsPending(false)} />
        )}
      </>
    );
  }

  return (
    <OrganisationMemberDetailsForm
      organisationDetailsFormData={organisationDetailsFormData}
      setOrganisationDetailsFormData={setOrganisationDetailsFormData}
      handleSubmitButtonClick={() => {
        setIsPending(true);
        dispatch(sendVerificationCode());
      }}
      accountVerificationStatus="VERIFY_ORG_PERSON_PHONE"
    />
  );
};

export default BiddingOrgPersonPhoneVerification;
